import { Form } from "react-bootstrap";
import Select from "react-select";
import OverviewLinkIcon from "./OverviewLinkIcon";
import { buildAutocompleteSelectStyles } from "./autocompleteSelectStyles";
import {
  clientsToSelectOptions,
  filterClientOption,
} from "./clientOptionUtils";

/**
 * Searchable client picker for long lists (react-select).
 */
export default function ClientAutocompleteSelect({
  label = "Client",
  required = false,
  className = "mb-3",
  clients = [],
  value,
  onChange,
  disabled = false,
  isInvalid = false,
  placeholder = "Type to search client…",
  overviewLinkEntity = "client",
}) {
  const options = clientsToSelectOptions(clients);
  const selected = options.find((o) => o.value === value) || null;
  const showLink =
    overviewLinkEntity &&
    value !== undefined &&
    value !== null &&
    String(value).trim() !== "";

  return (
    <Form.Group className={className}>
      {label ? (
        <Form.Label className="mb-1">
          {label}
          {required ? " *" : ""}
        </Form.Label>
      ) : null}
      <div className="d-flex align-items-start gap-2">
        <div className="flex-grow-1">
          <Select
            inputId="client-autocomplete"
            classNamePrefix="client-select"
            options={options}
            value={selected}
            onChange={(opt) => onChange(opt ? opt.value : "")}
            isDisabled={disabled}
            isClearable={!required}
            isSearchable
            placeholder={placeholder}
            filterOption={filterClientOption}
            styles={buildAutocompleteSelectStyles({ isInvalid })}
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            menuPosition="fixed"
            noOptionsMessage={({ inputValue }) =>
              inputValue ? "No matching clients" : "No clients loaded"
            }
          />
          {isInvalid ? (
            <div className="invalid-feedback d-block">Client is required.</div>
          ) : null}
        </div>
        {showLink ? (
          <div className="pt-2">
            <OverviewLinkIcon entity={overviewLinkEntity} id={value} newTab />
          </div>
        ) : null}
      </div>
    </Form.Group>
  );
}
